import {post} from "../utils";

export default host => profileUrl => {
  const form = new FormData();
  if (profileUrl && profileUrl.length > 0) form.append("profile_url", profileUrl);
  return post(
    `${host}/contentCreators/setProfileUrl`,
    form
  ).then(response => response.json());
}
  